const goalLinePlugin = {
  id: 'goalLinePlugin',
  afterDraw: function(chart) {
    const ctx = chart.ctx;
    const yScale = chart.scales['y-axis-0'];
    const firstDataset = chart.data.datasets[0];

    // Permitir desabilitar a linha de meta via opções do gráfico
    if (!chart.options || chart.options.showGoalLine === false) return;

    if (!firstDataset || !firstDataset.goalConsumption) return;
    
    const goalValue = firstDataset.unitMeasure === 'liters' ? 
        firstDataset.goalConsumption * 1000 : firstDataset.goalConsumption;
    const y = yScale.getPixelForValue(goalValue);

    ctx.save();
    ctx.beginPath();
    ctx.moveTo(chart.chartArea.left, y);
    ctx.lineTo(chart.chartArea.right, y);
    ctx.lineWidth = 2;
    ctx.strokeStyle = '#FF6B6B';
    ctx.setLineDash([5, 5]);
    ctx.stroke();
    ctx.restore();

    ctx.fillStyle = '#2d2d2eff';
    ctx.font = '13px Arial';
    ctx.fillText(`Meta: ${goalValue.toFixed(2)}`, chart.chartArea.right - 100, y - 8);
  }
};

export default goalLinePlugin;

